import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "bg-primary-light rounded-full w-9/12 m-auto p-1 text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExchangeCards = _resolveComponent("ExchangeCards")!
  const _component_CardWithTitle = _resolveComponent("CardWithTitle")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CardWithTitle, {
          title: _ctx.exchangeCardsTitle,
          class: "text-center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.exchangeCardsPointPrefix) + _toDisplayString(_ctx.wallet.point), 1),
            _createVNode(_component_ExchangeCards)
          ]),
          _: 1
        }, 8, ["title"])
      ]))
    : _createCommentVNode("", true)
}